import { render, staticRenderFns } from "./TagTableItem.vue?vue&type=template&id=b27ea906&scoped=true"
import script from "./TagTableItem.vue?vue&type=script&lang=js"
export * from "./TagTableItem.vue?vue&type=script&lang=js"
import style0 from "./TagTableItem.vue?vue&type=style&index=0&id=b27ea906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ea906",
  null
  
)

export default component.exports